import { ProvidedBy } from '@crow/ui';
import { apiFetch } from '@crowdex/host-kit/renderer/http';
import { InlineMessage } from '@crowdex/ui/components/feedback';
import { useEffect, useState } from 'react';
import {
  SettingRow,
  SettingsGroup,
  SettingValue,
} from '@/components/settings-page/setting-controls';
import { errorMessage } from '@/lib/error-message';

type DriveView = {
  id: string;
  title: string;
  available: boolean;
  /** Why CrowDrive cannot be used here ("Sign in to use CrowDrive"). */
  message?: string;
};

/**
 * The account's two file spaces (`docs/adr-two-file-spaces.md`): the Dossier, the conversation's
 * folder, and the Drive, CrowDrive always. Nothing to choose: Settings only says where they are.
 */
export function FilesSettings() {
  const [drive, setDrive] = useState<DriveView | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    apiFetch<{ drive: DriveView }>('/api/drive').then(
      (answer) => setDrive(answer?.drive ?? null),
      (reason: unknown) => setError(errorMessage(reason)),
    );
  }, []);

  return (
    <SettingsGroup title="Files">
      {error !== null && <InlineMessage tone="error">{error}</InlineMessage>}
      <SettingRow
        description="The conversation’s folder: its repository, or the default folder."
        title="Dossier"
      >
        <SettingValue>On the conversation’s machine</SettingValue>
      </SettingRow>
      <SettingRow
        description={
          drive === null || drive.available
            ? 'Your online files, shared with the other Crowlingo apps.'
            : (drive.message ?? 'CrowDrive is unavailable.')
        }
        title="Drive"
      >
        <ProvidedBy app="crowdrive" />
      </SettingRow>
    </SettingsGroup>
  );
}
